import React from "react";

export const AudioWave = ({ active = true, bars = 48, height = 72, className = "", levels = null }) => {
  if (levels && levels.length) {
    return (
      <div className={`flex items-end justify-center gap-[3px] ${className}`} style={{ height }} data-testid="audio-wave" aria-hidden="true">
        {levels.map((v, i) => (
          <span
            key={i}
            className="w-[4px] rounded-full origin-bottom"
            style={{
              height: "100%",
              background: "linear-gradient(to top, #1D4ED8, #06B6D4)",
              transform: `scaleY(${Math.max(0.06, v)})`,
              opacity: 0.55 + Math.min(0.45, v),
              transition: "transform 90ms linear, opacity 120ms linear",
            }}
          />
        ))}
      </div>
    );
  }
  return (
    <div
      className={`flex items-end justify-center gap-[3px] ${className}`}
      style={{ height }}
      data-testid="audio-wave"
      aria-hidden="true"
    >
      {Array.from({ length: bars }).map((_, i) => (
        <span
          key={i}
          className="w-[4px] rounded-full origin-bottom"
          style={{
            height: "100%",
            background: `linear-gradient(to top, #1D4ED8, #06B6D4)`,
            transform: active ? undefined : "scaleY(0.12)",
            animation: active ? `wave ${0.7 + ((i * 37) % 90) / 100}s ease-in-out ${(i % 11) * 0.07}s infinite` : "none",
            opacity: active ? 0.55 + ((i * 13) % 45) / 100 : 0.25,
            transition: "transform 300ms ease, opacity 300ms ease",
          }}
        />
      ))}
    </div>
  );
};
